import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { VersionInfoComponent } from './version-info.component';

@NgModule({
  declarations: [VersionInfoComponent],
  imports: [CommonModule, FormsModule, IonicModule],
  exports: [VersionInfoComponent]
})
export class VersionInfoModule {}
